import type { UnlikelyProduct } from "@unlikelystudio/commerce-connector"
import { useGetCustomer } from "@unlikelystudio/react-ecommerce-hooks"

import { getReferenceIdFromGID } from "~/lib/shopify/utils/id"
import useCurrency from "~/hooks/useCurrency"
import type { TVariant } from "~/components/ui/ProductHeader/_data/types"

const soClozServices = ["reservation"] as const

function useGetSoClozAttributes(
  product: UnlikelyProduct,
  service: (typeof soClozServices)[number],
  variant: TVariant | null
): Record<string, string | number> {
  const currency = useCurrency()
  const { data: customer } = useGetCustomer()
  const productId = getReferenceIdFromGID(product.id)

  return {
    ["product-id"]: String(productId),
    ...(variant?.sku ? { ["data-socloz-product-id"]: variant?.sku } : {}),
    ["data-socloz-service"]: service,
    ["data-socloz-product-attributes-clothes_size"]: String(variant?.size),
    ["data-socloz-currency"]: currency.toUpperCase(),
    ["data-socloz-signature-fields-0"]: "product.id",
    ["data-socloz-signature-fields-1"]: "sale_price",
    ["data-socloz-signature-fields-2"]: "currency",
    ["data-socloz-user-gender"]: 2, // default to first visible option in the selector,
    ...(customer?.email ? { ["data-socloz-user-email"]: customer?.email } : {}),
    ...(customer?.firstName ? { ["data-socloz-user-firstname"]: customer?.firstName } : {}),
    ...(customer?.lastName ? { ["data-socloz-user-lastname"]: customer?.lastName } : {}),
    ...(customer?.phone ? { ["data-socloz-user-phone"]: customer?.phone } : {}),
  }
}

export { useGetSoClozAttributes }
